(() => {
  const selector = [
    '.fyre-heading-block > span',
    '.dpp-build-goals__heading',
    '.fyre-slideshow__heading',
    '.fyre-youtube-gallery__heading',
    '.build-parts-heading',
    '.dpp-build-gallery__heading'
  ].join(',');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const reveal = (element) => {
    element.classList.add('is-revealed');
    observer?.unobserve(element);
  };

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window) || reducedMotion.matches) return observer;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      threshold: 0.25,
      rootMargin: '0px 0px -10% 0px'
    });

    return observer;
  };

  const initialize = (root = document) => {
    const elements = [];

    if (root instanceof Element && root.matches(selector)) elements.push(root);
    root.querySelectorAll?.(selector).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (element.classList.contains('dpp-build-heading-reveal')) return;

      element.classList.add('dpp-build-heading-reveal');

      const activeObserver = getObserver();
      if (activeObserver) {
        activeObserver.observe(element);
      } else {
        reveal(element);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:load', (event) => initialize(event.target));
})();
